import React, { useEffect } from "react"
import { NextSeo } from "next-seo"
import { observer } from 'mobx-react'

import { PARKING_FLOW_TYPE } from "~/utilities/constants"

import Layout from "~/components/parking/Layout"
import Landing from "~/components/parking/Landing"

import TRACKING from "~/services/tracking"
import useInject from "~/hooks/useInject"

const scrollUp = () => {
  if (process.browser) {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }
}

const mapStore = store => ({
  user: store.auth.user,
  isPayNYCFlow: store.ui.isPayNYCFlow,
})

const ParkingPayFlowPage = () => {
  const { user, isPayNYCFlow } = useInject(mapStore)

  useEffect(() => {
    scrollUp()
    if (isPayNYCFlow) {
      const emailOrigins = [
        "communicationsPayableEmail",
        "fromPayableTicketsNotification",
      ]
      const origin = emailOrigins.includes(user.origin) ? user.origin : null
      TRACKING.paynycParking.landing(isPayNYCFlow, origin)
    }
    if (["communicationsPayableEmail", "fromPayableTicketsNotification"].includes(user.origin)) { // set in email sent to user by Communications job on AWS
      TRACKING.parking.arrivedFromNycEmail(PARKING_FLOW_TYPE.pay, user.origin)
    }
  }, [])

  return (
    <>
      <NextSeo title="Pay your New York City parking tickets | WinIt" />
      <Layout>
        <Landing />
      </Layout>
    </>
  )
}

ParkingPayFlowPage.getInitialProps = async (ctx) => {
  if (ctx.store && ctx.store.parkingFlow.flow.setEntryType) {
    ctx.store.parkingFlow.flow.setEntryType(PARKING_FLOW_TYPE.pay)
    await ctx.store.plates.loadIfNecessary();
  }

  return {}
}

export default observer(ParkingPayFlowPage)
